import React, { useContext, useEffect, useState } from "react";
import "./Redeem.css";
import { axiosInstance } from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../Components/LanguageContext";
import translations from "./translation.json";

export function Redeem() {
  const { language } = useContext(LanguageContext);
  const [bank, setBank] = useState();
  const [accountNumber, setAccountNumber] = useState();
  const [ifsc, setIfsc] = useState();
  const [agentname, setAgentName] = useState();
  const [earnedPoints, setEarnedPoints] = useState();
  const [totalEarnedPoints, setTotalEarnedPoints] = useState();
  const [amount, setAmount] = useState();
  //   console.log("amount",amount);

  async function LoadData() {
    try {
      const response = await axiosInstance.get("profile");
      const details = response.data;
      setBank(details.data.bank);
      setIfsc(details.data.ifsc_code);
      setAccountNumber(details.data.account_number);
      setAgentName(details.data.full_name);
      setEarnedPoints(details.data.user_promo_code.points);
      setTotalEarnedPoints(details.data.total_earned_points);
    } catch (error) {
      toast.error("Unable to fetch data");
    }
  }

  async function handleWithdraw() {
    try {
      const numericAmount = Number(amount);
      if (!numericAmount || numericAmount <= 0) {
        toast.error("Please enter a valid amount");
      } else if (earnedPoints < 1000) {
        toast.error(
          "Insufficient balance. Minimum balance required is 1000 points."
        );
      } else if (numericAmount < 1000) {
        toast.error("Minimum withdrawal amount is 1000");
      } else {
        const numericAmount = Number(amount);
        const response = await axiosInstance.post("withdraw", {
          account_number: accountNumber,
          name: agentname,
          bank: bank,
          ifsc_code: ifsc,
          amount: numericAmount,
        });
        if (response.data.status === true) {
          toast.success(response.data.message || "Withdraw request sent");
          LoadData();
          setAmount("");
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (error) {
      console.error("Withdraw error:", error);

      toast.error("Enter Amount", error);
    }
  }

  useEffect(() => {
    LoadData();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="redeemBg">
        <div className="container redeemContainer">
          <div>
            <div className="account-title">
              {" "}
              {translations[language].account_details}
            </div>
            <div className="account-content">
              <div className="accountDetails">
                <span> {translations[language].name}:</span>
                <span>{agentname}</span>
              </div>
              <div className="accountDetails">
                <span> {translations[language].account_number} :</span>
                <span>{accountNumber}</span>
              </div>
              <div className="accountDetails">
                <span> {translations[language].bank_name} :</span>
                <span>{bank}</span>
              </div>
              <div className="accountDetails">
                <span> {translations[language].ifsc}:</span>
                <span>{ifsc}</span>
              </div>
              <div className="accountDetails">
                <span> {translations[language].available} :</span>
                <span>{earnedPoints}/-</span>
              </div>
              <div className="accountDetails">
                <span>{translations[language].MinimumWithdrawAmount}:</span>
                <span>{1000}/-</span>
              </div>
            </div>
            <div className="amountContainer">
              <label> {translations[language].enter} :</label>
              <input
                type="text"
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
              />
            </div>
            <div className="btnAmountSubmit">
              <button onClick={handleWithdraw}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
